import request from '@/utils/request';

/**
 * @description: 职位信息接口
 */

// 社会招聘外链、数量
export const urlAndCountBySociety = (data) => {
  return request.get('api/Res.Society/index?limit=20&page=1', { params: data });
}

// 校园招聘外链、数量
export const urlAndCountByCampus = (data) => {
  return request.get('api/Res.Campus/index?limit=20&page=1', { params: data });
}

// 招聘banner图
export const bannerImg = (data) => {
  return request.get('api/Res.ResBanner/index?limit=20&page=1', { params: data });
}

// 招聘列表
export const list = (data) => {
  return request.get('api/Res.Recruit/index', { params: data });
};

// 招聘详情
export const detail = (data) => {
  return request.get('api/Res.Recruit/view', { params: data });
};

// 投递简历
export const delivery = (data) => {
  return request.post('api/Res.ResumeSend/add', data, { authRequired: true });
};

// 招聘一级分类（社会招聘、校园招聘、高层次人才...）
export const category = (data) => {
  return request.get('api/Res.RecruitCatagory/index?limit=1000&page=1', { params: data });
};

// 招聘二级分类 - 职位类别
export const jobCategory = (data) => {
  return request.get('api/Res.JobCatagory/index?limit=1000&page=1', { params: data });
};

// 招聘二级分类 - 所属机构
export const jobOrganization = (data) => {
  return request.get('api/Res.Organization/index?limit=1000&page=1', { params: data });
};

// 招聘二级分类 - 学历要求
export const jobEducation = (data) => {
  return request.get('api/Res.Education/index?limit=1000&page=1', { params: data });
};

// 收藏 - 添加收藏
export const collectAdd = (data) => {
  return request.post('api/Res.Collect/add', data, { authRequired: true });
};

// 收藏 - 删除收藏
export const collectDelete = (data) => {
  return request.post('api/Res.Collect/delete', data, { authRequired: true });
};

// 收藏 - 收藏列表
export const collectList = (data) => {
  return request.post('api/Res.Collect/index?limit=1000&page=1', data, { authRequired: true });
};

// 收藏 - 是否已收藏
export const collectStatus = (id) => {
  return request.post(`api/Res.Collect/view?recruit_id=${id}`, '', { authRequired: true });
};
